<div class="w-full px-4 py-6">
    <div class="flex flex-wrap -mx-2 text-center">
        <div class="centered-box">
            <div class="flex flex-wrap -mx-2">
                <div class="w-full sm:ml-[8.333333%] sm:flex-none sm:w-5/6 px-2">
                    <figure>
                        <img src="../../assets/images/cbicon.svg" class="cb-icon" alt="SalesIntel">
                    </figure>
                    <h3 class="my-4">
                        Your trial has expired.<br />
                    </h3>
                    <p>Fill the contact form on our website to schedule a free demo or to request a trial account so
                        you can
                        experience the full power of our platform without any obligations.</p>
                    <p> Please reach us at <a title="support@salesintel.io" target="_blank"
                            href="mailto:support@salesintel.io">support&#64;salesintel.io</a>
                        if we can help you in any other way. Happy Prospecting!
                    </p>
                    <a matButton="filled" target="_blank" title="Schedule Demo" href="https://salesintel.io/request-a-demo/"
                        class="px-6">
                        Schedule Demo
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
